import script from "./DraggableWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./DraggableWrapper.vue?vue&type=script&setup=true&lang=js"

import "./DraggableWrapper.vue?vue&type=style&index=0&id=13049aac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13049aac"]])

export default __exports__